export default {
  id: null,
  nome: '',
  username: '',
  password: '',
  paId: null,
  tipoUsuario: null,
  mesasIds: [],
  midias: []
}



// WEBPACK FOOTER //
// ./src/shared/models/configurations/tvmodel.js